const event = {
  formId: "event-flow",
  formField: {
    eventName: {
      name: "eventName",
      label: "title",
      type: "text",
      placeholder: "placeholders.event_name",
      errorMsg: "Title is required."
    },
    description: {
      name: "description",
      label: "description",
      type: "editor",
      placeholder: "placeholders.event_description",
      errorMsg: "Description is required."
    },
    startDate: {
      name: "startDate",
      label: "Date",
      type: "date",
      placeholder: "",
      errorMsg: "Start Date is required."
    },
    startTime: {
      name: "startTime",
      label: "Time",
      type: "select",
      placeholder: "",
      errorMsg: "Start Time is required."
    },
    endDate: {
      name: "endDate",
      label: "Date",
      type: "date",
      placeholder: "",
      errorMsg: "End Date is required."
    },
    endTime: {
      name: "endTime",
      label: "Time",
      type: "select",
      placeholder: "",
      errorMsg: "End Time is required."
    },
    repeat: {
      name: "repeat",
      label: "Recurrence",
      type: "select",
      options: [
        { value: "not_repeat", label: "Does not repeat" },
        { value: "minutely", label: "Minutely" },
        { value: "hourly", label: "Hourly" },
        { value: "daily", label: "Daily" },
        { value: "weekly", label: "Weekly" },
        { value: "monthly", label: "Monthly" }
      ],
      placeholder: "",
      errorMsg: ""
    },
    repetition: {
      name: "repetition",
      label: "Repetition",
      type: "text",
      placeholder: "",
      errorMsg: "Invalid value"
    },
    repeatCount: {
      name: "repeat_count",
      label: "Repeat every",
      type: "select",
      options: Array.from({ length: 100 }, (v, i) => ({
        value: (i + 1).toString(),
        label: (i + 1).toString()
      }))
    }
  }
};

export default event;
